import Icon, { IconType } from 'components/Icon';
import { Tooltip } from 'components/Widget/Tooltip';
import { MenuItemAction } from 'menu/MenuItem';
import { useId } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { getSelectedFrameId, openCanvasLeft } from 'redux/mode/util';
import { RootReducer, selectSelectedFrames } from 'redux/reducers';
import { useTheme } from 'styled-components';
import * as Island from '../styles';

const BottomLeft = () => {
	const theme = useTheme();
	const tooltipId = useId();

	const { selectedFrameId, selectedFrames, canvasLeft } = useSelector(
		(r: RootReducer) => ({
			selectedFrameId: getSelectedFrameId(r.mode.selected),
			selectedFrames: selectSelectedFrames(r),
			canvasLeft: openCanvasLeft(r.mode),
		}),
		shallowEqual
	);

	const selectedFrame =
		selectedFrameId && selectedFrames.length === 1
			? selectedFrames.find((f) => f.id === selectedFrameId)
			: null;

	const iconSize = 14;

	//----------------------------------------------------------------------
	// RENDERING
	//----------------------------------------------------------------------
	const isActive = selectedFrame !== null;
	const onExpandPress = () => {
		if (selectedFrame) {
			MenuItemAction.createCenterFrame(selectedFrame).callback();
		}
	};

	return (
		<Island.BottomLeft left={canvasLeft}>
			<Island.ControlButton
				active={isActive}
				buttonType={Island.ButtonType.SINGLE}
				onClick={onExpandPress}
				data-tooltip-id={tooltipId}
				data-tooltip-content={isActive ? 'Focus frame (double-click)' : 'Select a frame to focus'}
			>
				<Island.IconWrapper>
					<Icon
						type={IconType.FULLSCREEN}
						width={iconSize}
						height={iconSize}
						color={isActive ? theme.gray[1000] : theme.gray[400]}
					/>
				</Island.IconWrapper>
			</Island.ControlButton>
			<Tooltip id={tooltipId} placement="top" />
		</Island.BottomLeft>
	);
};

export default BottomLeft;
